"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeHtml = escapeHtml;
exports.translateHtml = translateHtml;
const index_1 = require("./index");
/**
 * Escapes a value for Telegram's HTML parse mode. Ampersand first, so the entities produced
 * for the other characters are not escaped again. `"` is covered so a value is safe inside a
 * double-quoted attribute such as `<a href="{txUrl}">`.
 */
function escapeHtml(value) {
    return value
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;');
}
/**
 * `translate` for messages the bot sends with `parse_mode: 'HTML'`. Markup belongs to the
 * catalogue string only; every parameter is escaped, so a Telegram first name, a card mask or
 * a currency name from the exchanger can never open or close a tag.
 */
function translateHtml(locale, key, params = {}) {
    const escaped = {};
    for (const [name, value] of Object.entries(params))
        escaped[name] = escapeHtml(String(value));
    return (0, index_1.translate)(locale, key, escaped);
}
//# sourceMappingURL=html.js.map